import classNames from 'classnames'
import {memo} from 'react'

import type {AddedParameterItem, ModifiedParameterItem, ParameterItem} from '../../Parameters.types'
import {ItemType} from '../../Parameters.types'
import {ParameterHighlight} from '../Highligh/ParameterHighligh'
import {ParametersRow} from '../Row/ParametersRow'

import styles from './ParametersItem.css'

interface Props {
  item: ParameterItem | ModifiedParameterItem | AddedParameterItem
}

function ParametersItemComponent(props: Props) {
  const {item} = props

  return (
    <ParametersRow
      role={'cell'}
      className={classNames(styles.content, {
        [styles.addedParameter]: item.type === ItemType.ADDED_PARAMETER,
        [styles.modifiedParameter]: item.type === ItemType.MODIFIED_PARAMETER,
      })}
      name={<ParameterHighlight value={item.name} highlight={item.highlight} />}
      value={
        <>
          <div>
            <ParameterHighlight value={item.value} highlight={item.highlight} />
          </div>
          {item.type === ItemType.MODIFIED_PARAMETER && (
            <div className={styles.defaultValue}>
              <div>{'Was default:'}</div>
              <div>
                <ParameterHighlight value={item.defaultValue} highlight={item.highlight} />
              </div>
            </div>
          )}
        </>
      }
    />
  )
}

export const ParametersItem = memo<Props>(ParametersItemComponent)
